<template>
  <div class="overflow-x-auto shadow-md rounded-lg">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-blue-500">
        <tr>
          <th v-for="header in tableHeaders" 
              :key="header.key" 
              @click="sortBy(header.key)"
              class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider cursor-pointer hover:bg-blue-600 transition-colors">
            {{ header.label }}
            <span v-if="sortKey === header.key" class="ml-1">
              {{ sortOrder === 'asc' ? '↑' : '↓' }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="pedido in sortedOrders" 
            :key="pedido.id"
            :class="[
              'hover:bg-gray-50 transition-colors',
              isExpired(pedido.expiry_date) ? 'bg-red-300' && pedido.order_state != 'finish' : '',
              pedido.order_state === 'finish'? 'bg-green-300' : ''
            ]">
          <td class="px-6 py-4 whitespace-nowrap">{{ pedido.id }}</td>
          <td class="px-6 py-4 whitespace-nowrap">{{ formatDate(pedido.date) }}</td>
          <td class="px-6 py-4 whitespace-nowrap">{{ formatDate(pedido.expiry_date) }}</td>
          <td class="px-6 py-4 whitespace-nowrap">{{ pedido.comentary }}</td>
          <td class="px-6 py-4 whitespace-nowrap">{{ pedido.items }}</td>
          <td class="px-6 py-4 whitespace-nowrap">${{ formatCurrency(pedido.balance) }}</td>
          <td class="px-6 py-4 whitespace-nowrap">${{ formatCurrency(pedido.total) }}</td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span :class="getStatusClass(pedido.order_state)">
              {{ getState(pedido.order_state) }}
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
            <a :href="`/web/order/${pedido.id}`" 
               class="text-blue-600 hover:text-blue-900 hover:underline transition-colors">Ver</a>
            <template v-if="pedido.order_state === 'request'">
              <span class="text-gray-300">|</span>
              <a :href="`/web/payments/${pedido.id}`" 
                 class="text-red-600 hover:text-red-900 hover:underline transition-colors">Pagar</a>
            </template>
          </td>
        </tr>
        <tr v-if="!sortedOrders.length" class="text-center">
          <td colspan="8" class="px-6 py-4 text-gray-500">No hay pedidos disponibles</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'OrdersTable',
  props: {
    orders: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      sortKey: 'id',
      sortOrder: 'desc',
      tableHeaders: [
        { key: 'id', label: '#' },
        { key: 'date', label: 'Fecha' },
        { key: 'expiry_date', label: 'Fecha de vencimiento' },
        { key: 'comentary', label: 'Descripción' },
        { key: 'items', label: 'Items' },
        { key: 'balance', label: 'Pagado' },
        { key: 'total', label: 'Monto' },
        { key: 'order_state', label: 'Estado' },
        { key: 'actions', label: 'Acción' }
      ]
    }
  },
  computed: {
    sortedOrders() {
      return [...this.orders].sort((a, b) => {
        let aValue = a[this.sortKey]
        let bValue = b[this.sortKey]

        // Handle numeric values
        if (this.sortKey === 'balance' || this.sortKey === 'total' || this.sortKey === 'id') {
          aValue = parseFloat(aValue)
          bValue = parseFloat(bValue)
        }

        if (aValue < bValue) return this.sortOrder === 'asc' ? -1 : 1
        if (aValue > bValue) return this.sortOrder === 'asc' ? 1 : -1
        return 0
      })
    }
  },
  methods: {
    isExpired(date) {
      if (!date) return false
      const expiryDate = new Date(date)
      const today = new Date()
      return expiryDate < today
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'asc'
      }
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    formatCurrency(value) {
      return parseFloat(value).toFixed(2)
    },
    getState(state) {
      const states = {
        request: 'Pendiente por pago',
        estimate: 'Presupuesto',
        picking: 'Preparando pedido',
        packing: 'Preparando pedido',
        transport: 'En transporte',
        finish: 'Entregado'
      }
      return states[state] || state
    },
    getStatusClass(state) {
      const baseClasses = 'px-2 inline-flex text-xs leading-5 font-semibold rounded-full'
      const statusClasses = {
        request: 'bg-yellow-100 text-yellow-800',
        estimate: 'bg-blue-100 text-blue-800',
        picking: 'bg-purple-100 text-purple-800',
        packing: 'bg-purple-100 text-purple-800',
        transport: 'bg-orange-100 text-orange-800',
        finish: 'bg-green-100 text-green-800'
      }
      return `${baseClasses} ${statusClasses[state] || 'bg-gray-100 text-gray-800'}`
    }
  }
}
</script>